import { render, staticRenderFns } from "./FacilityPrinterDetail.vue?vue&type=template&id=ba3b16c6&"
import script from "./FacilityPrinterDetail.vue?vue&type=script&lang=js&"
export * from "./FacilityPrinterDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports